import React, { useEffect, useRef, useState } from "react";
import {
  Col,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  Button,
  Icon,
  RSelect,
} from "../../components/Component";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { toast } from "react-toastify";
import Table from "../../components/react-table/Table";
import { useUser } from "../../context/user";
import { GET, POST } from "../../helper/api";
import { inventoryInColTable, inventoryOutInsideColTable, pnCustomerMoneyFlowListColTable } from "../../utils/col-table";
import { SETTING_KEY } from "../../utils/Utils";


const DEFAULT_WAITING_REVIEW = {
  reviewerId: ''
}

const ReportAssignTransactionHistoryPN = () => {
  const {
    state: { user },
  } = useUser();
  const {
    errors,
    handleSubmit,
    getValues,
    control,
  } = useForm({
    defaultValues: {
      ...DEFAULT_WAITING_REVIEW
    },
  });

  const printRef = useRef();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [timeNow, setTimeNow] = useState();
  const [userOptions, setUserOptions] = useState([]);
  const [listDayNotYetRequestReview, setListDayNotYetRequestReview] = useState([]);
  const [needApproveByUser, setNeedApproveByUser] = useState([]);

  const history = useHistory();
  const [data, setData] = useState({
    transactionHistories: {
      rows: [],
      summary: {}
    },
    customerMoneyFlows: {
      rows: [],
      summary: {}
    },
    inventoryInTransactions: {
      rows: [],
      summary: {}
    },
    inventoryOutTransactions: {
      rows: [],
      summary: {}
    },
  });

  const [view, setView] = useState({
    addReport: false,
    agreeReport: false,
    cancelReport: false,
    unConfirmReport: false,
  });


  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const [filter, setFilter] = useState({
    date: searchParams.get('date') ? moment(searchParams.get('date')).format('YYYY-MM-DD') : moment().add(-1, 'days').format('YYYY-MM-DD'),
  });

  const colTable = [
    {
      Header: "Ngày",
      accessor: (item) => moment(item.date).format("DD/MM/YYYY"),
    },
    {
      Header: "NH",
      accessor: (item) => item.bankAccount?.name
    },
    {
      Header: "Nội dung",
      accessor: (item) => item?.content || "",
    },
    {
      Header: "Danh mục",
      accessor: (item) => item?.category?.name || "",
    },
    {
      Header: "Tiền thu(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.inAmount}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Tiền chi(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.outAmount}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Hợp đồng",
      accessor: (item) => item.contractId || '',
    },
  ]

  const colTableCustomerMoneyFlow = pnCustomerMoneyFlowListColTable();

  const inventoryInCol = inventoryInColTable({
    actionCol: []
  })

  const inventoryOutInsideCol = inventoryOutInsideColTable({
    actionCol: []
  })

  const exportExcel = () => {
    const params = new URLSearchParams({
      startDate: moment(filter.date).format("YYYY-MM-DD"),
      endDate: moment(filter.date).format("YYYY-MM-DD"),
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/pn/list-excel-report-by-day?${params.toString()}`;
    window.open(url, '_blank')
  };



  useEffect(() => {
    GET(`/user/list-can-confirm-assign-review/${SETTING_KEY.ASSIGN_REVIEWER_PN_TRANSACTION_HISTORY}`, {}, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });
  }, []);
  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      date: filter.date,

    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })
    setLoading(true);
    setData([]);
    let params = {
      date: filter.date,
    };
    GET(`/pn/report-by-day`, params, true)
      .then(({ data: {
        transactionHistories,
        customerMoneyFlows,
        inventoryInTransactions,
        inventoryOutTransactions,
        isChecked, listDayNotYetRequestReview, needApproveByUser } }) => {
        setIsChecked(isChecked);
        setData({
          transactionHistories,
          customerMoneyFlows,
          inventoryInTransactions,
          inventoryOutTransactions,
        })
        setListDayNotYetRequestReview(listDayNotYetRequestReview.map(e => moment(e, 'YYYY-MM-DD').format('DD')))
        setNeedApproveByUser(needApproveByUser.map(e => moment(e, 'YYYY-MM-DD').format('DD-MM-YYYY')))
      })
      .finally(() => {
        setLoading(false);
      });
  }, [filter, timeNow]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ addReport: false, agreeReport: false, cancelReport: false, unConfirmReport: false });
  };

  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  const unConfirmReportAssignReport = () => {
    let payload = {
      date: filter.date,
    };
    POST(`/pn/unconfirm-request-assign`, payload, {}, true)
      .then((res) => {
        toast.success("Huỷ duyệt báo cáo thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };
  const cancelReportAssignReport = () => {
    let payload = {
      date: filter.date,
    };
    POST(`/pn/cancel-report-assign`, payload, {}, true)
      .then((res) => {
        toast.success("Huỷ yêu cầu duyệt báo cáo thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const addReportWaitingApprovedTransaction = () => {
    const { reviewerId } = getValues();
    let params = {
      date: filter.date,
      reviewerId
    };
    POST(`/pn/add-report-assign`, {}, params, true)
      .then((res) => {
        toast.success("Gửi yê cầu duyệt báo cáo thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };


  const actionReportAssignTransaction = (agree) => {
    if (!isChecked) {
      return;
    }
    const { id } = isChecked;
    POST(`/pn/action-request-assign/${id}`, {
      agree,
    }, {}, true)
      .then((res) => {
        toast.success("Duyệt báo cáo thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  return (
    <React.Fragment>
      <Head title="Quản lý giao dịch"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input placeholder="Lọc theo ngày" onChange={(e) => setFilter({
                          ...filter,
                          date: e.target.value
                        })} value={filter.date} type="date" className="form-control" />

                      </div>
                    </li>

                    {!isChecked ? <li>
                      <div>
                        <Button
                          color="secondary"
                          onClick={() => {
                            toggle('addReport')
                          }}
                        >
                          <span>Gửi báo cáo</span>
                        </Button>
                      </div>
                    </li> : <></>}
                    {(isChecked && !isChecked.confirmedAt && isChecked.reviewerId === user.id) ? <li>
                      <div>
                        <Button
                          color="secondary"
                          onClick={() => {
                            toggle('agreeReport')
                          }}
                        >
                          <span>Duyệt báo cáo</span>
                        </Button>
                      </div>
                    </li> : <></>}
                    {
                      isChecked && !isChecked.confirmedAt ? <li className="">
                        <div className="">
                          <Button
                            className=""
                            color="warning"
                            onClick={() => {
                              toggle('cancelReport')
                            }}
                          >
                            <span>Huỷ yêu cầu duyệt báo cáo</span>
                          </Button>
                        </div>
                      </li> : null
                    }
                    {(isChecked && isChecked.confirmedAt && isChecked.reviewerId === user.id) ? <li>
                      <div>
                        <Button
                          color="secondary"
                          onClick={() => {
                            toggle('unConfirmReport')
                          }}
                        >
                          <span>Huỷ duyệt báo cáo</span>
                        </Button>
                      </div>
                    </li> : <></>}
                    <li>
                      <ReactToPrint
                        trigger={() => <Button className={`btn-secondary`}>In</Button>}
                        content={() => printRef.current}
                        pageStyle={``}
                      />
                    </li>
                    {/* <li className="">
                      <div className="">
                        <Button
                          className=""
                          color="secondary"
                          onClick={exportExcel}
                        >
                          <span>Xuất excel</span>
                        </Button>
                      </div>
                    </li> */}
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div>
                  <h6>Ngày chưa gửi báo cáo trong tháng: <span className="font-weight-normal">{listDayNotYetRequestReview?.join(', ')}</span></h6>
                  <h6>Ngày chưa duyệt: <span className="font-weight-normal">{needApproveByUser?.join(', ')}</span></h6>
                </div>
                <div className="text-center">
                  {!isChecked ? <h4 style={{ fontSize: `28px important`, color: '#e85347' }} className="text-center" >Chưa gửi báo cáo</h4> : <></>}
                  {isChecked && !isChecked.confirmedAt ? <h4 style={{ fontSize: `28px important`, color: '#e85347' }} className="text-center" >Chưa duyệt báo cáo</h4> : <></>}
                  {isChecked && isChecked.confirmedAt ? <h4 style={{ fontSize: `28px important`, color: '#e85347' }} className="text-center" >Đã duyệt báo cáo</h4> : <></>}
                </div>
                <div className="my-3" ref={printRef}>


                  <h5 className="text-center">Báo cáo từ ngày {moment(filter.date).format('DD-MM-YYYY')} đến {moment(filter.date).format('DD-MM-YYYY')}</h5>

                  <h6 className="mt-2 text-center">Chi tiết thu chi</h6>
                  <Table
                    style={{
                      minHeight: 'unset !important',
                      // pageBreakAfter: 'always'
                    }}
                    loading={loading}
                    columns={colTable}
                    data={data?.transactionHistories?.rows || []}
                    notShowPagi={true}
                    headerRow={<tr className="nk-tb-item odd font-weight-bold">
                      <td colSpan={4} className="nk-tb-col">
                        Tổng cộng: {data?.transactionHistories?.rows?.length || 0} đơn
                      </td>
                      <td className="nk-tb-col text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={data?.transactionHistories?.summary?.totalAmountIn}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td className="nk-tb-col text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={data?.transactionHistories?.summary?.totalAmountOut}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td></td>
                    </tr>}
                  ></Table>

                  <h6 className="mt-2 text-center">Chi tiết thu chi KH/NCC</h6>

                  <Table
                    style={{
                      minHeight: 'unset !important',
                      // pageBreakAfter: 'always'
                    }}
                    loading={loading}
                    columns={colTableCustomerMoneyFlow}
                    data={data?.customerMoneyFlows?.rows || []}
                    notShowPagi={true}
                    headerRow={<tr className="nk-tb-item odd font-weight-bold">
                      <td colSpan={8} className="nk-tb-col">
                        Tổng cộng: {data?.customerMoneyFlows?.rows?.length || 0} đơn
                      </td>
                      <td colSpan={1} className="text-right"><NumericFormat
                        displayType={"text"}
                        value={data?.customerMoneyFlows?.summary?.inTotal}
                        thousandsGroupStyle="thousand"
                        thousandSeparator=","
                        decimalScale={2}
                      /></td>
                      <td colSpan={1} className="text-right"><NumericFormat
                        displayType={"text"}
                        value={data?.customerMoneyFlows?.summary?.outTotal}
                        thousandsGroupStyle="thousand"
                        thousandSeparator=","
                        decimalScale={2}
                      /></td>
                    </tr>}
                  ></Table>

                  <h6 className="mt-2 text-center">Chi tiết nhập nhiên liệu</h6>
                  <Table
                    style={{
                      minHeight: 'unset !important',
                      // pageBreakAfter: 'always'
                    }}
                    loading={loading}
                    columns={inventoryInCol}
                    data={data?.inventoryInTransactions?.rows || []}
                    notShowPagi={true}
                    headerRow={<tr className="nk-tb-item odd font-weight-bold">
                      <td colSpan={3} className="nk-tb-col">
                        Tổng cộng: {data?.inventoryInTransactions?.rows?.length || 0} đơn
                      </td>
                      <td className="nk-tb-col text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={data?.inventoryInTransactions?.summary?.total}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td colSpan={4}></td>
                    </tr>}
                  ></Table>

                  <h6 className="mt-2 text-center">Chi tiết xuất nhiên liệu</h6>
                  <Table
                    style={{
                      minHeight: 'unset !important',
                      // pageBreakAfter: 'always'
                    }}
                    loading={loading}
                    columns={inventoryOutInsideCol}
                    data={data?.inventoryOutTransactions?.rows || []}
                    notShowPagi={true}
                    headerRow={<tr className="nk-tb-item odd font-weight-bold">
                      <td colSpan={4} className="nk-tb-col">
                        Tổng cộng: {data?.inventoryOutTransactions?.rows?.length || 0} đơn
                      </td>
                      <td className="nk-tb-col text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={data?.inventoryOutTransactions?.summary?.total}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td colSpan={3}></td>

                    </tr>}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
        <Modal isOpen={view.addReport} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-list bg-success"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn gửi duyệt báo cáo này không?
              </h4>
              <form className="text-left" onSubmit={handleSubmit(addReportWaitingApprovedTransaction)}>
                <Row>
                  <Col md="12">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        Người duyệt
                        <span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="reviewerId"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, name, ref }) => (
                            <RSelect
                              classNamePrefix="form-control"
                              inputRef={ref}
                              name={name}
                              options={userOptions}
                              value={userOptions.find(
                                (c) => c.value === value
                              )}
                              onChange={(val) => onChange(val.value)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="reviewerId"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <div className="nk-modal-action mt-5 d-flex justify-content-around">
                  <Button
                    type={'button'}
                    color="light"
                    size="lg"
                    className="btn-mw mr-5"
                    onClick={() => onFormCancel()}
                  >
                    Huỷ bỏ
                  </Button>
                  <Button
                    color="primary"
                    size="lg"
                    className="btn-mw"
                  >
                    Xác nhận
                  </Button>
                </div>
              </form>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.agreeReport} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-list bg-success"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn duyệt báo cáo này không?
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  type={'button'}
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={() => actionReportAssignTransaction(true)}
                >
                  Đồng ý
                </Button>

                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={() => actionReportAssignTransaction(false)}
                >
                  Từ chối
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>


        <Modal isOpen={view.unConfirmReport} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-list bg-success"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn huỷ duyệt báo cáo này không?
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  type={'button'}
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={() => unConfirmReportAssignReport()}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>


        <Modal isOpen={view.cancelReport} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-list bg-success"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn huỷ yêu cầu duyệt báo cáo này không?
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  type={'button'}
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={() => cancelReportAssignReport()}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content >
    </React.Fragment >
  );
};

export default ReportAssignTransactionHistoryPN;
